export default __webpack_public_path__ + "static/media/mobile-cropped-mymove.5d36e55d.png";